module.exports = __webpack_public_path__ + "front/img/3.c17a19a6.png";